// 🤖 Samsung 스마트폰 데이터 (간소화된 구조)
import type { SamsungSeriesData } from './deviceDataHelpers';

export const SAMSUNG_PHONE_DATA: SamsungSeriesData[] = [
  {
    series: 'Galaxy S',
    models: [
      // S25 시리즈
      { en: 'Galaxy S25', ko: '갤럭시 S25', storages: ['128GB', '256GB'], year: 2025, recommended: true },
      { en: 'Galaxy S25+', ko: '갤럭시 S25+', storages: ['256GB', '512GB'], year: 2025, recommended: true },
      { en: 'Galaxy S25 Ultra', ko: '갤럭시 S25 울트라', storages: ['256GB', '512GB', '1TB'], year: 2025, recommended: true },
      { en: 'Galaxy S25 Edge', ko: '갤럭시 S25 엣지', storages: ['256GB', '512GB'], year: 2025 },
      { en: 'Galaxy S25 FE', ko: '갤럭시 S25 FE', storages: ['128GB', '256GB', '512GB'], year: 2025 },
      
      // S24 시리즈
      { en: 'Galaxy S24', ko: '갤럭시 S24', storages: ['128GB', '256GB'], year: 2024, recommended: true },
      { en: 'Galaxy S24+', ko: '갤럭시 S24+', storages: ['256GB', '512GB'], year: 2024, recommended: true },
      { en: 'Galaxy S24 Ultra', ko: '갤럭시 S24 울트라', storages: ['256GB', '512GB', '1TB'], year: 2024, recommended: true },
      { en: 'Galaxy S24 FE', ko: '갤럭시 S24 FE', storages: ['128GB', '256GB'], year: 2024 },
      
      // S23 시리즈
      { en: 'Galaxy S23', ko: '갤럭시 S23', storages: ['128GB', '256GB'], year: 2023 },
      { en: 'Galaxy S23+', ko: '갤럭시 S23+', storages: ['256GB', '512GB'], year: 2023 },
      { en: 'Galaxy S23 Ultra', ko: '갤럭시 S23 울트라', storages: ['256GB', '512GB', '1TB'], year: 2023 },
      { en: 'Galaxy S23 FE', ko: '갤럭시 S23 FE', storages: ['128GB', '256GB'], year: 2023 },
      
      // S22 시리즈
      { en: 'Galaxy S22', ko: '갤럭시 S22', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy S22+', ko: '갤럭시 S22+', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy S22 Ultra', ko: '갤럭시 S22 울트라', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2022 },
      
      // S21 시리즈
      { en: 'Galaxy S21', ko: '갤럭시 S21', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy S21+', ko: '갤럭시 S21+', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy S21 Ultra', ko: '갤럭시 S21 울트라', storages: ['128GB', '256GB', '512GB'], year: 2021 },
      { en: 'Galaxy S21 FE', ko: '갤럭시 S21 FE', storages: ['128GB', '256GB'], year: 2021 },
      
      // S20 시리즈
      { en: 'Galaxy S20', ko: '갤럭시 S20', storages: ['128GB'], year: 2020 },
      { en: 'Galaxy S20+', ko: '갤럭시 S20+', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      { en: 'Galaxy S20 Ultra', ko: '갤럭시 S20 울트라', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      { en: 'Galaxy S20 FE', ko: '갤럭시 S20 FE', storages: ['128GB', '256GB'], year: 2020 },
      
      // S10 시리즈
      { en: 'Galaxy S10e', ko: '갤럭시 S10e', storages: ['128GB', '256GB'], year: 2019 },
      { en: 'Galaxy S10', ko: '갤럭시 S10', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2019 },
      { en: 'Galaxy S10+', ko: '갤럭시 S10+', storages: ['128GB', '256GB', '512GB', '1TB'], year: 2019 },
      { en: 'Galaxy S10 5G', ko: '갤럭시 S10 5G', storages: ['256GB', '512GB', '1TB'], year: 2019 },
      { en: 'Galaxy S10 Lite', ko: '갤럭시 S10 라이트', storages: ['128GB', '512GB'], year: 2020 },
      
      // S9 시리즈
      { en: 'Galaxy S9', ko: '갤럭시 S9', storages: ['64GB', '128GB', '256GB'], year: 2018 },
      { en: 'Galaxy S9+', ko: '갤럭시 S9+', storages: ['64GB', '128GB', '256GB'], year: 2018 },
      
      // S8 시리즈
      { en: 'Galaxy S8', ko: '갤럭시 S8', storages: ['64GB'], year: 2017 },
      { en: 'Galaxy S8+', ko: '갤럭시 S8+', storages: ['64GB'], year: 2017 },
      
      // S7 시리즈
      { en: 'Galaxy S7', ko: '갤럭시 S7', storages: ['32GB', '64GB', '128GB'], year: 2016 },
      { en: 'Galaxy S7 Edge', ko: '갤럭시 S7 엣지', storages: ['32GB', '64GB', '128GB'], year: 2016 },
      
      // S6 시리즈
      { en: 'Galaxy S6', ko: '갤럭시 S6', storages: ['32GB', '64GB', '128GB'], year: 2015 },
      { en: 'Galaxy S6 Edge', ko: '갤럭시 S6 엣지', storages: ['32GB', '64GB', '128GB'], year: 2015 },
      { en: 'Galaxy S6 Edge+', ko: '갤럭시 S6 엣지+', storages: ['32GB', '64GB'], year: 2015 }
    ]
  },
  {
    series: 'Galaxy Z Flip',
    models: [
      { en: 'Galaxy Z Flip', ko: '갤럭시 Z 플립', storages: ['256GB'], year: 2020 },
      { en: 'Galaxy Z Flip 5G', ko: '갤럭시 Z 플립 5G', storages: ['256GB'], year: 2020 },
      { en: 'Galaxy Z Flip3 5G', ko: '갤럭시 Z 플립3 5G', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy Z Flip4', ko: '갤럭시 Z 플립4', storages: ['128GB', '256GB', '512GB'], year: 2022 },
      { en: 'Galaxy Z Flip5', ko: '갤럭시 Z 플립5', storages: ['256GB', '512GB'], year: 2023 },
      { en: 'Galaxy Z Flip6', ko: '갤럭시 Z 플립6', storages: ['256GB', '512GB'], year: 2024, recommended: true },
      { en: 'Galaxy Z Flip7', ko: '갤럭시 Z 플립7', storages: ['256GB', '512GB'], year: 2025 },
      { en: 'Galaxy Z Flip7 FE', ko: '갤럭시 Z 플립7 FE', storages: ['128GB', '256GB'], year: 2025 }
    ]
  },
  {
    series: 'Galaxy Z Fold',
    models: [
      { en: 'Galaxy Fold', ko: '갤럭시 폴드', storages: ['512GB'], year: 2019 },
      { en: 'Galaxy Z Fold2 5G', ko: '갤럭시 Z 폴드2 5G', storages: ['256GB', '512GB'], year: 2020 },
      { en: 'Galaxy Z Fold3 5G', ko: '갤럭시 Z 폴드3 5G', storages: ['256GB', '512GB'], year: 2021 },
      { en: 'Galaxy Z Fold4', ko: '갤럭시 Z 폴드4', storages: ['256GB', '512GB', '1TB'], year: 2022 },
      { en: 'Galaxy Z Fold5', ko: '갤럭시 Z 폴드5', storages: ['256GB', '512GB', '1TB'], year: 2023 },
      { en: 'Galaxy Z Fold6', ko: '갤럭시 Z 폴드6', storages: ['256GB', '512GB', '1TB'], year: 2024, recommended: true },
      { en: 'Galaxy Z Fold7', ko: '갤럭시 Z 폴드7', storages: ['256GB', '512GB', '1TB'], year: 2025 }
    ]
  },
  {
    series: 'Galaxy Note',
    models: [
      { en: 'Galaxy Note20 Ultra', ko: '갤럭시 노트20 울트라', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      { en: 'Galaxy Note20', ko: '갤럭시 노트20', storages: ['128GB', '256GB'], year: 2020 },
      { en: 'Galaxy Note10', ko: '갤럭시 노트10', storages: ['256GB'], year: 2019 },
      { en: 'Galaxy Note10+', ko: '갤럭시 노트10+', storages: ['256GB', '512GB'], year: 2019 },
      { en: 'Galaxy Note10+ 5G', ko: '갤럭시 노트10+ 5G', storages: ['256GB', '512GB'], year: 2019 },
      { en: 'Galaxy Note10 Lite', ko: '갤럭시 노트10 라이트', storages: ['128GB'], year: 2020 },
      { en: 'Galaxy Note9', ko: '갤럭시 노트9', storages: ['128GB', '512GB'], year: 2018 },
      { en: 'Galaxy Note8', ko: '갤럭시 노트8', storages: ['64GB', '128GB', '256GB'], year: 2017 },
      { en: 'Galaxy Note FE', ko: '갤럭시 노트 FE', storages: ['64GB'], year: 2017 },
      { en: 'Galaxy Note7', ko: '갤럭시 노트7', storages: ['64GB'], year: 2016 },
      { en: 'Galaxy Note5', ko: '갤럭시 노트5', storages: ['32GB', '64GB', '128GB'], year: 2015 },
      { en: 'Galaxy Note4', ko: '갤럭시 노트4', storages: ['32GB'], year: 2014 },
      { en: 'Galaxy Note Edge', ko: '갤럭시 노트 엣지', storages: ['32GB', '64GB'], year: 2014 },
      { en: 'Galaxy Note 3', ko: '갤럭시 노트3', storages: ['16GB', '32GB', '64GB'], year: 2013 },
      { en: 'Galaxy Note 3 Neo', ko: '갤럭시 노트3 네오', storages: ['16GB', '32GB'], year: 2013 }
    ]
  },
  {
    series: 'Galaxy A',
    models: [
      // A50-90 시리즈
      { en: 'Galaxy A55 5G', ko: '갤럭시 A55 5G', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy A54 5G', ko: '갤럭시 A54 5G', storages: ['128GB', '256GB'], year: 2023 },
      { en: 'Galaxy A53 5G', ko: '갤럭시 A53 5G', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy A52', ko: '갤럭시 A52', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy A52 5G', ko: '갤럭시 A52 5G', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy A52s 5G', ko: '갤럭시 A52s 5G', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy A51', ko: '갤럭시 A51', storages: ['64GB', '128GB', '256GB'], year: 2020 },
      { en: 'Galaxy A51 5G', ko: '갤럭시 A51 5G', storages: ['128GB'], year: 2020 },
      { en: 'Galaxy A50', ko: '갤럭시 A50', storages: ['64GB', '128GB'], year: 2019 },
      
      // A30-40 시리즈
      { en: 'Galaxy A35 5G', ko: '갤럭시 A35 5G', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy A34 5G', ko: '갤럭시 A34 5G', storages: ['128GB', '256GB'], year: 2023 },
      { en: 'Galaxy A33 5G', ko: '갤럭시 A33 5G', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy A32', ko: '갤럭시 A32', storages: ['64GB', '128GB'], year: 2021 },
      { en: 'Galaxy A32 5G', ko: '갤럭시 A32 5G', storages: ['64GB', '128GB'], year: 2021 },
      { en: 'Galaxy A31', ko: '갤럭시 A31', storages: ['64GB', '128GB'], year: 2020 },
      { en: 'Galaxy A30', ko: '갤럭시 A30', storages: ['32GB', '64GB'], year: 2019 },
      
      // A20-30 시리즈
      { en: 'Galaxy A25 5G', ko: '갤럭시 A25 5G', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy A24', ko: '갤럭시 A24', storages: ['128GB'], year: 2023 },
      { en: 'Galaxy A23', ko: '갤럭시 A23', storages: ['64GB', '128GB'], year: 2022 },
      { en: 'Galaxy A23 5G', ko: '갤럭시 A23 5G', storages: ['64GB', '128GB'], year: 2022 },
      { en: 'Galaxy A22', ko: '갤럭시 A22', storages: ['64GB', '128GB'], year: 2021 },
      { en: 'Galaxy A22 5G', ko: '갤럭시 A22 5G', storages: ['64GB', '128GB'], year: 2021 },
      { en: 'Galaxy A21s', ko: '갤럭시 A21s', storages: ['32GB', '64GB', '128GB'], year: 2020 },
      { en: 'Galaxy A20', ko: '갤럭시 A20', storages: ['32GB'], year: 2019 },
      
      // A10-20 시리즈
      { en: 'Galaxy A15', ko: '갤럭시 A15', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy A15 5G', ko: '갤럭시 A15 5G', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy A14', ko: '갤럭시 A14', storages: ['64GB', '128GB'], year: 2023 },
      { en: 'Galaxy A14 5G', ko: '갤럭시 A14 5G', storages: ['64GB', '128GB'], year: 2023 },
      { en: 'Galaxy A13', ko: '갤럭시 A13', storages: ['64GB', '128GB'], year: 2022 },
      { en: 'Galaxy A12', ko: '갤럭시 A12', storages: ['32GB', '64GB', '128GB'], year: 2021 },
      { en: 'Galaxy A11', ko: '갤럭시 A11', storages: ['32GB'], year: 2020 },
      { en: 'Galaxy A10', ko: '갤럭시 A10', storages: ['32GB'], year: 2019 },
      
      // A70-90 시리즈
      { en: 'Galaxy A42 5G', ko: '갤럭시 A42 5G', storages: ['128GB'], year: 2020 },
      { en: 'Galaxy A73 5G', ko: '갤럭시 A73 5G', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy A72', ko: '갤럭시 A72', storages: ['128GB', '256GB'], year: 2021 },
      { en: 'Galaxy A71', ko: '갤럭시 A71', storages: ['128GB'], year: 2020 },
      { en: 'Galaxy A70', ko: '갤럭시 A70', storages: ['128GB'], year: 2019 },
      { en: 'Galaxy A80', ko: '갤럭시 A80', storages: ['128GB'], year: 2019 },
      { en: 'Galaxy A90 5G', ko: '갤럭시 A90 5G', storages: ['128GB'], year: 2019 }
    ]
  },
  {
    series: 'Galaxy J',
    models: [
      // J1 시리즈
      { en: 'Galaxy J1', ko: '갤럭시 J1', storages: ['4GB'], year: 2015 },
      { en: 'Galaxy J1 Ace', ko: '갤럭시 J1 에이스', storages: ['4GB', '8GB'], year: 2015 },
      { en: 'Galaxy J1 (2016)', ko: '갤럭시 J1 (2016)', storages: ['8GB'], year: 2016 },
      { en: 'Galaxy J1 Nxt', ko: '갤럭시 J1 넥스트 (J1 미니)', storages: ['8GB'], year: 2016 },
      { en: 'Galaxy J1 mini prime', ko: '갤럭시 J1 미니 프라임', storages: ['8GB'], year: 2016 },
      
      // J2 시리즈
      { en: 'Galaxy J2', ko: '갤럭시 J2', storages: ['8GB'], year: 2015 },
      { en: 'Galaxy J2 (2016)', ko: '갤럭시 J2 (2016)', storages: ['8GB'], year: 2016 },
      { en: 'Galaxy J2 Prime', ko: '갤럭시 J2 프라임', storages: ['8GB', '16GB'], year: 2016 },
      { en: 'Galaxy J2 Pro (2018)', ko: '갤럭시 J2 프로 (2018)', storages: ['16GB', '32GB'], year: 2018 },
      { en: 'Galaxy J2 Core', ko: '갤럭시 J2 코어', storages: ['8GB', '16GB'], year: 2018 },
      
      // J3 시리즈
      { en: 'Galaxy J3 (2016)', ko: '갤럭시 J3 (2016)', storages: ['8GB', '16GB'], year: 2016 },
      { en: 'Galaxy J3 (2017)', ko: '갤럭시 J3 (2017)', storages: ['16GB'], year: 2017 },
      { en: 'Galaxy J3 Prime (2017)', ko: '갤럭시 J3 프라임 (2017)', storages: ['16GB'], year: 2017 },
      { en: 'Galaxy J3 (2018)', ko: '갤럭시 J3 (2018)', storages: ['16GB'], year: 2018 },
      
      // J4-J8 시리즈  
      { en: 'Galaxy J4', ko: '갤럭시 J4', storages: ['16GB', '32GB'], year: 2018 },
      { en: 'Galaxy J4+', ko: '갤럭시 J4 플러스', storages: ['16GB', '32GB'], year: 2018 },
      { en: 'Galaxy J4 Core', ko: '갤럭시 J4 코어', storages: ['16GB'], year: 2018 },
      { en: 'Galaxy J5 (2015)', ko: '갤럭시 J5 (2015)', storages: ['8GB', '16GB'], year: 2015 },
      { en: 'Galaxy J5 (2016)', ko: '갤럭시 J5 (2016)', storages: ['16GB'], year: 2016 },
      { en: 'Galaxy J5 Prime', ko: '갤럭시 J5 프라임', storages: ['16GB', '32GB'], year: 2016 },
      { en: 'Galaxy J5 (2017)', ko: '갤럭시 J5 (2017)', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy J5 Pro (2017)', ko: '갤럭시 J5 프로 (2017)', storages: ['32GB'], year: 2017 },
      { en: 'Galaxy J6', ko: '갤럭시 J6', storages: ['32GB', '64GB'], year: 2018 },
      { en: 'Galaxy J6+', ko: '갤럭시 J6 플러스', storages: ['32GB', '64GB'], year: 2018 },
      { en: 'Galaxy J7 (2015)', ko: '갤럭시 J7 (2015)', storages: ['8GB', '16GB', '32GB'], year: 2015 },
      { en: 'Galaxy J7 (2016)', ko: '갤럭시 J7 (2016)', storages: ['16GB'], year: 2016 },
      { en: 'Galaxy J7 Prime', ko: '갤럭시 J7 프라임', storages: ['16GB', '32GB', '64GB'], year: 2016 },
      { en: 'Galaxy J7 Prime 2', ko: '갤럭시 J7 프라임 2', storages: ['32GB'], year: 2018 },
      { en: 'Galaxy J7 Pro', ko: '갤럭시 J7 프로', storages: ['32GB', '64GB'], year: 2017 },
      { en: 'Galaxy J7 Max', ko: '갤럭시 J7 맥스', storages: ['32GB'], year: 2017 },
      { en: 'Galaxy J7 Nxt', ko: '갤럭시 J7 넥스트', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy J7 Neo', ko: '갤럭시 J7 네오', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy J7 Core', ko: '갤럭시 J7 코어', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy J7 (2017)', ko: '갤럭시 J7 (2017)', storages: ['16GB', '32GB', '64GB'], year: 2017 },
      { en: 'Galaxy J7 (2018)', ko: '갤럭시 J7 (2018)', storages: ['16GB', '32GB'], year: 2018 },
      { en: 'Galaxy J7 Duo', ko: '갤럭시 J7 듀오', storages: ['32GB'], year: 2018 },
      { en: 'Galaxy J8', ko: '갤럭시 J8', storages: ['32GB', '64GB'], year: 2018 }
    ]
  }
];
